var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeartFilledBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.949989 6.22874C-0.228632 4.9361 -0.320694 2.99114 0.730595 1.59359C2.10293 -0.230759 4.80014 -0.363237 6.34567 1.31779L7 2.02949L7.65433 1.31779C9.19986 -0.363235 11.8971 -0.230761 13.2694 1.59359C14.3207 2.99114 14.2286 4.9361 13.05 6.22874L7 12.864L0.949989 6.22874Z",
    fill: "#3399CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartFilledBlue);
export default __webpack_public_path__ + "static/media/heart-filled-blue.2fbad4b078e34aa80d6d9e43c5be5ec6.svg";
export { ForwardRef as ReactComponent };